export const orderStatus = (status) => ({
  new: "Нове", in_work: "В роботі", delivered: "Доставка", success: "Готово", canceled: "Скасоване",
}[status] || "Статус не зазначено");

export const orderPayment = (status) => ({
  pending: "Очікує оплати", paid: "Оплачено", refunded: "Бали повернено",
}[status] || "Статус оплати не зазначено");

export const orderDate = (value) => {
  if (!value || !Number.isFinite(new Date(value).getTime())) return "Дата не зазначена";
  return new Date(value).toLocaleString("uk-UA");
};

export const orderPoints = (value) => value === null || value === undefined
  ? "Не зазначено" : `${Number(value).toLocaleString("uk-UA")} балів`;

export function ordersPage(result) {
  const meta = result?.meta;
  if (!Array.isArray(result?.data) || !meta ||
      ![meta.current_page, meta.last_page, meta.per_page].every(value => Number.isInteger(value) && value > 0) ||
      !Number.isInteger(meta.total) || meta.total < 0 ||
      !result.data.every(order => Number.isInteger(order.id) && order.id > 0)) {
    throw new Error("Некоректна відповідь історії замовлень.");
  }
  return result;
}

export function orderDetail(result, id) {
  const order = result?.data;
  if (!order || String(order.id) !== String(id) || !Array.isArray(order.items) ||
      !order.receiving || !Array.isArray(order.receiving.methods)) {
    throw new Error("Некоректна відповідь замовлення.");
  }
  return order;
}

export function historyLocation(hash) {
  const params = new URLSearchParams(hash.replace(/^#orders\??/, ""));
  const page = Number(params.get("page"));
  const order = params.get("order");
  return { page: Number.isInteger(page) && page > 0 && page <= 100000 ? page : 1,
    order: /^[1-9][0-9]{0,18}$/.test(order || "") ? order : null };
}
